module.exports = __webpack_public_path__ + "static/media/hmv.5809b03e.png";